import {useState, useEffect} from 'react';
import {addLabelToArray} from '../helpers';
import {useApi} from '../context';

export function useIndustries(props) {
    let api = useApi();

    const [isLoading, setIsLoading] = useState(true);
    const [industries, setIndustries] = useState([]);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        
        const fetchData = async() => {
            setIsLoading(true)
            let results = null;

                results = await api.getTaglines();
          
            if(results.statusCode === 200) {
                let {data, message} = results;

                    let labelledData = (addLabelToArray(data.reverse()));
                    setIndustries(labelledData)
              
            } 
            else {
                let {error} = results;
                setHasError(error);
            }
            // setIsLoading(false);
        }

        fetchData();
        return () => { 
            return [industries, isLoading, hasError ]
        }
    }, [])

    return {industries, isLoading, hasError}
}

export function useOneIndustry(props) {
    let api = useApi();

    const [isLoading, setIsLoading] = useState(true);
    const [industry, setIndustries] = useState({});
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        
        const fetchData = async() => {
            setIsLoading(true)
            let results = null;

                results = await api.getOneIndustry(props.id);
          
            if(results.statusCode === 200) {
                let {data, message} = results;

                   
                    setIndustries(data)
              
            } 
            else {
                let {error} = results;
                setHasError(error);
            }
            // setIsLoading(false);
        }

        fetchData();
        return () => { 
            return [industry, isLoading, hasError ]
        }
    }, [])

    return {industry, isLoading, hasError}
}
